/* eslint-disable max-len */
const Z_INDEX = {
  SLIDER_BUTTON: 2,
};

const desktop = theme => {
  return {
    container: {
      height: 'unset',
      minHeight: 'unset',
    },
    upperSection: {
      paddingBottom: 30,
    },
    slider: {
      height: 'unset',
    },
    carouselImage: {
      width: '100%',
      height: 'auto',
      maxHeight: '50vh',
      // avoid image distortion
      objectFit: 'contain',
      clipPath: 'inset(0px 4px)',
    },
    squareButtonContainer: {
      marginRight: 32,
    },
    lowerSection: {
      // backgroundImage: "url('/images-mobile/home/lower-section-background-desktop.svg')",
    },
    buttonField: {display: 'flex', flexDirection: 'row', justifyContent: 'center'},
    cardField: {
      // display: 'flex',
      flexWrap: 'wrap',
      // justifyContent: 'space-evenly',
      // padding: '0px 5px 20px 5px',
      // width: '90%',
      // margin: '0 auto',
      padding: '0 15px',

      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(min-content, 180px));',
      gridAutoRows: '1fr',
      // gridTemplateRows: ' auto auto auto',
      justifyContent: 'space-between',
      gap: 10,
    },
    gameDemoBtn: {
      color: 'white',
      fontSize: '18px',
      lineHeight: '100%',
      width: '45%',
      height: '50px',
      margin: '0px auto 20px auto',
      border: '1px solid #FFFCF4',
      boxShadow: '2px 2px 3px #934F00ED',
      background: 'transparent url(/images-mobile/home/game_demo_btn.webp) no-repeat center',
      backgroundSize: '100%',
      '&.ant-btn': {
        '&:hover, &:focus, &:active, &[disabled]': {
          color: 'white',
          border: '1px solid #FFFCF4',

          background: 'transparent url(/images-mobile/home/game_demo_btn.webp) no-repeat center',
          backgroundSize: '100%',
        },
      },
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    gameStartBtn: {
      extend: 'gameDemoBtn',
      background: 'transparent url(/images-mobile/home/game_start_btn.webp) center',
      backgroundSize: 'auto',
      backgroundPosition: 'center',
      '&.ant-btn': {
        '&:hover, &:focus, &:active, &[disabled]': {
          background: 'transparent url(/images-mobile/home/game_start_btn.webp) center',
          backgroundSize: 'auto',
        },
      },
    },
    gameButtonImage: {
      height: '85px',
      transform: 'translateY(-10px)',
    },
    arrowButtonSection: {
      '& .ant-btn': {
        background: 'transparent',
        color: 'white',
        height: '32px',
        width: '32px',
        padding: '0px',
        marginRight: '5px',
        '&:hover, &:focus, &:active': {
          borderColor: 'white',
        },
      },
    },
  };
};
const mobile = theme => {
  return {
    modalSpin: {
      display: 'block',
      textAlign: 'center',
    },
    modalTitle: {
      textAlign: 'center',
      width: '100%',
      display: 'block',
      marginBottom: '20px',
      fontWeight: '600',
    },
    announcementPopup: {
      '& .ant-tabs': {
        color: 'white',
        height: '50vh',
      },
      '& .ant-tabs-tab': {
        whiteSpace: 'pre-wrap',
        textAlign: 'left !important',
        padding: '2px 10px !important',
      },
      '& .ant-tabs-left >.ant-tabs-nav': {
        width: '30%',
      },
      '& .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn': {
        color: '#F3B331',
      },
      '& .ant-tabs-ink-bar': {
        backgroundColor: '#F3B331',
      },
      '& .ant-tabs-tab:hover': {
        color: '#cfcfcf',
      },
      '& .ant-tabs-content-holder': {
        overflowY: 'auto',
      },
      '& .ant-tabs-content': {
        backdropFilter: 'blur(1px)',
        whiteSpace: 'pre-wrap',
      },
    },
    container: {
      height: '100vh',
    },
    depositAmountTitle: {
      marginBottom: 10,
      color: theme.textColor,
      fontSize: 18,
    },
    upperSection: {
      width: '100%',
      backgroundSize: '100% 101px',
      backgroundColor: '#202633',
      position: 'relative',
    },
    bannerUpperBackground: {
      height: 101,
      width: '100%',
      position: 'absolute',
      top: 0,
    },
    bannerLowerBackground: {
      height: 94,
      width: '100%',
      position: 'absolute',
      bottom: 0,
    },
    descriptionRow: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '0px 15px',
      marginTop: 20,
    },
    playerStatistics: {
      paddingTop: 15,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '0px 10px',
    },
    spin: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '10vh',
    },
    sliderSection: {
      minHeight: '20vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    skeleton: {
      height: '20vh',
      width: 'calc(100% - 80px)',
      borderRadius: 10,
      margin: 'auto',
    },
    slider: {
      // mixBlendMode: 'plus-lighter',
      width: '100%',
      // height: '214px',
      // margin: '0 15px',
      // '& .slick-prev':{
      //   left:'3% !important',
      //   zIndex:1
      // },
      // '& .slick-next':{
      //   right:'3% !important',
      //   zIndex:1
      // },
      // paddingLeft: '20px',
      '& .slick-dots li button': {
        '&:before': {
          color: '#4F83EB',
        },
        '&:after': {
          color: 'rgba(255, 255, 255, 0.25)',
        },
      },
    },
    carouselImage: {
      width: '100%',
      margin: 'auto',
    },
    prevButton: {
      position: 'absolute',
      zIndex: Z_INDEX.SLIDER_BUTTON,
      left: '2.5%',
      // boxShadow: 'inset 0px 0px 4px rgba(255, 255, 255, 0.25);',
      width: '25px',
      height: '25px',
      // backgroundColor: '#29183E',
      boxShadow:
        '-5px -5px 10px 0px rgba(255, 255, 255, 0.05), 5px 5px 10px 0px rgba(0, 0, 0, 0.25), 1px 1px 1px 0px rgba(255, 255, 255, 0.10) inset',
      background:
        'linear-gradient(90deg, rgba(255, 255, 255, 0.05) 0%, rgba(153, 153, 153, 0.05) 100%)',
      borderRadius: '50%',
      border: 'none',
      color: theme.textColor,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      '&.ant-btn': {
        '&:hover, &:focus, &:active, &[disabled]': {
          background:
            'linear-gradient(90deg, rgba(255, 255, 255, 0.05) 0%, rgba(153, 153, 153, 0.05) 100%)',
          border: 'none',
        },
      },
    },
    nextButton: {
      extend: 'prevButton',
      left: 'unset',
      right: '2.5%',
    },
    arrowImage: {
      width: 6,
      height: 10,
    },
    antdTable: {
      '& .ant-table': {
        background: 'black',
      },
      '& .ant-table-thead>tr>th': {
        border: 'none',
        background: 'transparent',
        color: '#807e7e',
      },
      '& .ant-table-tbody>tr>td': {
        border: 'none',
      },
      '&.ant-table-tbody > tr.ant-table-row:hover > td, .ant-table-tbody > tr > td.ant-table-cell-row-hover':
        {
          background: '#1f1f1f',
        },
      '& .darkRow': {
        backgroundColor: '#141414',
      },
      '& .darkerRow': {
        backgroundColor: '#000000',
      },
    },
    colText: {
      color: 'white',
    },
    gradientText: {
      background: 'linear-gradient(45deg, #f39c12, #d35400)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
    },
    darkRow: {
      backgroundColor: '#1e1e1e',
    },
    darkerRow: {
      backgroundColor: '#141414',
    },
    header: {
      background: '#333',
      color: '#bb86fc',
      fontWeight: 'bold',
    },
    bodyCell: {
      border: 'none',
      color: '#fff',
    },
    goldenButtonsSection: {
      // textAlign: 'center'
      display: 'flex',
      justifyContent: 'space-around',
      margin: 10,
    },
    buttonField: {textAlign: 'center'},
    goldenDivider: {
      position: 'absolute',
      bottom: 0,
      transform: 'translateY(50%)',
    },
    dividerLeft: {
      height: 20,
      backgroundImage: "url('/images-mobile/home/divider-left.webp')",
      backgroundSize: '100% 20px',
      width: 'inherit',
    },
    dividerMid: {
      width: 52,

      height: '100%',
      backgroundImage: "url('/images-mobile/home/divider-mid.webp')",
    },
    dividerRight: {
      height: 20,
      backgroundImage: "url('/images-mobile/home/divider-right.webp')",
      backgroundSize: '100% 20px',
      width: 'inherit',
    },
    lowerSection: {
      backgroundColor: '#202633',
      // backgroundImage: "url('/images-mobile/home/lower-section-background.svg')",
      backgroundSize: 'cover',
      display: 'flex',
      flexDirection: 'column',
    },
    gameDemoBtn: {
      color: 'white',
      fontSize: '16px',
      lineHeight: '100%',
      width: '90%',
      margin: '0px auto 20px auto',
      border: '1px solid #FFFCF4',
      boxShadow: '2px 2px 3px #934F00ED',
      background: 'transparent url(/images-mobile/home/game_demo_btn.webp) no-repeat center',
      backgroundSize: '100%',
      '&.ant-btn': {
        '&:hover, &:focus, &:active, &[disabled]': {
          color: 'white',
          border: '1px solid #FFFCF4',
          background: 'transparent url(/images-mobile/home/game_demo_btn.webp) no-repeat center',
          backgroundSize: '100%',
        },
      },
    },
    myGameDescription: {
      color: 'white',
      fontSize: '17px',
      // padding: '50px 0 20px 30px',
      // opacity: '0.5',
    },
    gameRecordButton: {
      padding: 0,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      fontSize: 14,
      fontWeight: 600,
      background: 'linear-gradient(90deg, #33C4E8 0%, #4A65F2 100%)',
      backgroundClip: 'text',
      '-webkit-background-clip': 'text',
      '-webkit-text-fill-color': 'transparent',
      '&.ant-btn': {
        '&:hover, &:focus, &:active, &[disabled]': {
          backgroundClip: 'text',
          background: 'linear-gradient(90deg, #33C4E8 0%, #4A65F2 100%)',
          '-webkit-background-clip': 'text',
          '-webkit-text-fill-color': 'transparent',
        },
      },
    },
    buttonsRow: {
      width: '100%',
      margin: '30px 0',
    },
    squareButtonContainer: {
      padding: '0 15px',
      display: 'flex',
      flexDirection: 'row',
    },
    squareButton: {
      padding: 5,
      borderRadius: 16,
      background:
        'linear-gradient(90deg, rgba(255, 255, 255, 0.05) 0%, rgba(153, 153, 153, 0.05) 100%)',
      border: 'none',
      display: 'flex',
      flexDirection: 'row',
      width: 60,
      height: 60,
      boxShadow:
        '-5px -5px 10px 0px rgba(255, 255, 255, 0.05), 5px 5px 10px 0px rgba(0, 0, 0, 0.25), 1px 1px 1px 0px rgba(255, 255, 255, 0.10) inset',
      '&.ant-btn': {
        '&:hover, &:focus, &:active, &[disabled]': {
          background:
            'linear-gradient(90deg, rgba(255, 255, 255, 0.05) 0%, rgba(153, 153, 153, 0.05) 100%)',
          border: 'none',
        },
      },
    },
    blackBorder: {
      border: '1px solid #16191B',
      borderRadius: 10,
      width: '100%',
      height: '100%',
      padding: 5,
      '&:hover, &:focus, &:active, &[disabled]': {
        border: '1px solid #16191B',
      },
    },
    innerBlackBorder: {
      border: '1px solid #16191B',
      width: '100%',
      height: '100%',
      borderRadius: 5,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '&:hover, &:focus, &:active, &[disabled]': {
        border: '1px solid #16191B',
      },
    },
    buttonTextContainer: {
      marginLeft: 5,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    cardField: {
      // display: 'flex',
      flexWrap: 'wrap',
      // justifyContent: 'space-evenly',
      // padding: '0px 5px 20px 5px',
      // width: '90%',
      // margin: '0 auto',
      padding: '0 15px',

      gridAutoRows: '1fr',
      display: 'grid',
      gridTemplateColumns: 'repeat(2, minmax(0, 1fr));',
      // gridTemplateRows: ' auto auto auto',
      justifyItems: 'center',
      gap: 10,
    },
    modalImageDiv: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: '20px',
    },
    modalContent: {
      display: 'block',
      fontSize: '16px',
      textAlign: 'center',
      fontWeight: 'bold',
      color: '#D5D5D5',
      marginBottom: '10px',
    },
    openOrEnterRoomModal: {
      '& .ant-modal-footer': {
        // paddingBottom: '15px !important',
      },
    },
    customDrawer: {},
    gameTypeModalBody: {
      fontSize: '20px',
      color: 'white',
      background:
        // eslint-disable-next-line max-len
        'url("/images-mobile/CustomizedModal/UpperPart_BG_Border.webp")',
      backgroundPosition: 'top center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100%',
    },
    gameTypeModalTitle: {
      width: '100%',
      color: 'white',
      borderBottom: '1px solid #BEBEBE',
      marginBottom: '15px',
    },
    gameTypeModalContent: {
      width: '100%',
      display: 'grid',
      gridTemplateColumns: 'auto',
      gridGap: '10px',
      paddingTop: '15px',
      paddingBottom: '15px',
      '& .buttonInFooter': {
        width: '100%',
        marginTop: '10px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        whiteSpace: 'normal',
        background:
          // eslint-disable-next-line max-len
          'linear-gradient(155.28deg, #411C40 0%, #040105 33.33%, #010002 66.67%, #200B32 100%)',
        boxShadow: '0px 0px 5px rgba(205, 125, 204, 0.3)',
        borderRadius: '10px',
        '& .spanInFooter': {
          whiteSpace: 'normal',
          flex: '1 1 auto',
        },
      },
    },
    roomCodeModalBody: {
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
    },
    antdInput: {
      background: 'black !important',
      color: 'white',
      border: 'none',
      fontSize: 16,
      // margin: '10px',
      width: '85%',
    },
    confirmButton: {
      margin: '0 auto',
      width: '85%',
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
